import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useFetchWrapper as Api } from '../../utils';
import { HTTP_STATUS } from '../../components/constants';

const SKIP_ERROR_SNACKBAR_HEADER = { 'X-Skip-Error-Snackbar': true };

const initialState: any = {
  details: {},
  loading: false,
  rows: [],
  count: 0,
  publicKeyAddEditLoader: false,
};

export const getPublicKeyDetails: any = createAsyncThunk(
  'publicKey/getPublicKeyDetails',
  async (apiPath) => {
    const data = await Api().get(apiPath, null, SKIP_ERROR_SNACKBAR_HEADER);

    if (data instanceof Error || data?.messageCode === 'ERR_MS_0047') {
      return { data: [], statusCode: HTTP_STATUS.OK };
    }

    return data;
  },
);

export const publicKeyDetailSlice = createSlice({
  name: 'publicKeyDetails',
  initialState,
  reducers: {
    setPublicKeyAddEditLoader: (state: any, { payload }) => {
      state.publicKeyAddEditLoader = payload;
      state.loading = payload;
    },
    addNewRow: (state: any, { payload }) => {
      state.rows = [...state.rows, payload];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPublicKeyDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPublicKeyDetails.fulfilled, (state, action) => {
      state.loading = false;
      const responseData = action?.payload?.data;
      let records: any[] = [];

      if (Array.isArray(responseData)) {
        records = responseData;
      } else if (responseData?.records) {
        records = responseData.records;
      } else if (
        responseData &&
        typeof responseData === 'object' &&
        (responseData.ID || responseData.MerchantID)
      ) {
        records = [responseData];
      }

      state.rows = records;
      state.count = responseData?.total_count ?? records.length;
    });
    builder.addCase(getPublicKeyDetails.rejected, (state, action) => {
      state.loading = false;
      state.rows = [];
      state.count = 0;
      state.error = action.payload;
    });
  },
});

export const publicKeyDetailsData = (state: any) => state?.publicKeyDetails;

export const { setPublicKeyAddEditLoader, addNewRow } = publicKeyDetailSlice.actions;

export default publicKeyDetailSlice.reducer;
